module.exports = {"totalLabel":"De R$ 13.500,00","indicatorLabel":{"received":"Total recebido","toReceive":"Total a receber"},"chartData":{"received":9000,"toReceive":4500}}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/ec/DashboardResume/receipts/chart/data.json
// module id = 2241
// module chunks = 0